import React from 'react';
import { User, Settings, LogOut, Star } from 'lucide-react';
import { auth } from '../firebase/config';
import { signOut } from 'firebase/auth';

function Header({ user, mspData, setActivePage }) {
    
    const planNames = {
        'startup': 'Startup',
        'starter': 'Starter',
        'advanced': 'Advanced',
        'custom': 'Personalizado'
    };

    const planName = planNames[mspData?.plan] || mspData?.plan;

    return (
        <header className="p-3 border-bottom shadow-sm bg-body">
            <div className="d-flex justify-content-end align-items-center">
                
                {planName && (
                    <span className="badge bg-primary me-3 d-inline-flex align-items-center" style={{ pointerEvents: 'none' }}>
                        <Star size={12} className="me-1" />
                        {planName}
                    </span>
                )}

                <div className="dropdown text-end">
                    <button className="d-block link-body-emphasis text-decoration-none dropdown-toggle border-0 bg-transparent p-0" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="text-muted small me-2">{mspData.companyName || user.email}</span>
                        <img 
                            src={mspData.photoURL || `https://ui-avatars.com/api/?name=${user.email}&background=0D6EFD&color=fff&size=32`} 
                            alt="avatar do utilizador" 
                            width="32" 
                            height="32" 
                            className="rounded-circle"
                        />
                    </button>
                    <ul className="dropdown-menu text-small">
                        <li>
                            <button className="dropdown-item" onClick={() => setActivePage('profile')}>
                                <User className="me-2" size={16}/>Meu Perfil
                            </button>
                        </li>
                        <li>
                            <button className="dropdown-item" onClick={() => setActivePage('settings')}>
                                <Settings className="me-2" size={16}/>Configurações
                            </button>
                        </li>
                        <li><hr className="dropdown-divider" /></li>
                        <li>
                            <button className="dropdown-item text-danger" onClick={() => signOut(auth)}>
                                <LogOut className="me-2" size={16}/>Sair
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
}

export default Header;
